import { ContentBlocksModuleLayout, ModuleType } from "entities/modules/types";
import { THREE_CARD_BLOCK_KEY } from "entities/modules/utils";
import { getDoc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { DocumentData, DocumentReference, store } from "shared/api/firebase";
import { PageModuleData } from "../types";

type Params = {
  moduleRef: DocumentReference<DocumentData>;
  brandId: string;
  moduleId: string;
  pageId: string;
};

export const deleteContentBlocksModuleImages = async ({
  moduleRef,
  brandId,
  moduleId,
  pageId,
}: Params) => {
  const module = (await getDoc(moduleRef)).data() as PageModuleData;

  if (
    module.type !== ModuleType.ContentBlocks ||
    module.layout !== ContentBlocksModuleLayout.ThreeCardBlock ||
    !module.contentBlocks ||
    !module.contentBlocks?.length
  ) {
    return null;
  }

  try {
    await Promise.all(
      module.contentBlocks.map(async (item, index) => {
        if (!item.backgroundImage) {
          return null;
        }
        // References for logo and background images
        const path = `brands/${brandId}/pages/${pageId}/modules/${moduleId}/${THREE_CARD_BLOCK_KEY}-${index}`;
        const imgStorageRef = ref(store, path);

        await deleteObject(imgStorageRef);
      }),
    );
  } catch (error) {
    console.error("Error deleting page module image:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
